var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"tw-w-full",staticStyle:{"height":"75%"}},[_c('Map')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }